import AxiosClient from '@classpass/dal/axios-client';
import { trackApiRequest, trackApiResult } from 'helpers/statsd';
import * as logger from 'universal-logger';
import publicEndpoints, { ignoredStatusCodes } from 'endpoints';

const CONSECUTIVE_DIGITS = /\/[\d]{1,}/gi;
const IGNORED_ERRORS = ['404'];

export const transportErrorHandler = error => {
  const { details, name, message, method, httpStatus, url: requestUrl } = error;
  const statusString = httpStatus.toString();
  const isIgnoredError = IGNORED_ERRORS.includes(statusString);
  const isIgnoredEndpointError = ignoredStatusCodes[name] && ignoredStatusCodes[name].includes(statusString);
  const shouldLog = !isIgnoredError && !isIgnoredEndpointError && ['4', '5'].includes(statusString[0]);

  if (shouldLog) {
    const loggerMethod = statusString.startsWith('5') ? logger.error : logger.warn;

    const endpointTemplate = publicEndpoints[name] && publicEndpoints[name][1];
    const normalizedUrl = endpointTemplate || requestUrl.replace(CONSECUTIVE_DIGITS, '/xxx');

    loggerMethod(`${statusString} ${method.toUpperCase()} ${normalizedUrl}`, {
      details,
      httpStatus,
      message,
      name,
      url: requestUrl,
    });
  }
};

export const transportDecorator = (axios, endpoint, options = {}) => {
  const transport = new AxiosClient({
    axios,
    credentials: {
      token: options.token,
    },
    apiBase: endpoint,
    options: {
      timeout: options.timeout || 15000,
    },
  });

  transport.on('failure', transportErrorHandler);

  if (options.trackRequestTimings) {
    transport.on('request', event => trackApiRequest('server', event));
    transport.on('success', event => trackApiResult('server', event));
    transport.on('failure', event => trackApiResult('server', event));
  }

  const serverApiRequests = [];

  if (options.enableRequestLog) {
    transport.on('success', event => serverApiRequests.push(['success', event]));
    transport.on('failure', event => serverApiRequests.push(['failure', event]));

    // these are both development-only so ignoring
    transport.on('success', event =>
      // eslint-disable-next-line no-console
      console.log(
        `API \x1b[37m${event.method}\x1b[0m to \x1b[33m${event.name}\x1b[0m took \x1b[35m${event.duration}ms\x1b[0m`
      )
    );
    transport.on('failure', event =>
      // eslint-disable-next-line no-console
      console.log(
        `\x1b[31mAPI Failure ${event.code}!\x1b[0m \x1b[37m${event.method}\x1b[0m to \x1b[33m${event.name}\x1b[0m took \x1b[35m${event.duration}ms\x1b[0m`
      )
    );
  }

  return { transport, requestLog: serverApiRequests };
};
